'use strict'
var ReactDOM = require('react-dom');
var React = require('react');

import {HighlightReport} from './views/HighlightReport.jsx';
import {Organization} from './views/Organization.jsx';

import {Risk} from './views/Risk.jsx';
import {Change} from './views/Change.jsx';

import Portfolio from './views/Portfolio.jsx';
import ProjectMenu from './views/components/ProjectMenu.jsx';

import {AccountCreated} from './views/settings/AccountCreated.jsx';
import {TemplateOverview} from './views/admin/TemplateOverview.jsx';
import {ReportContent} from './views/Report.jsx';
import {NewProject} from './views/NewProject.jsx';
import {ProgrammeProperties} from './views/programme/ProgrammeProperties.jsx';
import {ProductProperties} from './views/product/ProductProperties.jsx';
import {ReleaseProperties} from './views/product/ReleaseProperties.jsx';
import {ProductDetails} from './views/product/ProductDetails.jsx';
import {NewExtremeProject} from './views/NewExtremeProject.jsx';
import {Search} from './views/Layout.jsx';
import {ProjectDefinition} from './views/definition/ProjectDefinition.jsx';
import {ProjectProductDescription} from './views/quality/ProjectProductDescription.jsx';
import {BusinessCase} from './views/businessCase/BusinessCase.jsx';
import {Plan} from './views/plan/Plan.jsx';
import {RiskManagementApproach} from './views/risk/Approach.jsx';
import {ChangeControlApproach} from './views/change/Approach.jsx';
import {CommunicationManagementApproach} from './views/organization/Approach.jsx';
import {ProjectSettings} from './views/settings/ProjectSettings.jsx';
import {Brief} from './views/brief/ProjectBrief.jsx';
import {InitiationDocument} from './views/pid/InitiationDocument.jsx';
import {ProgrammeDetails} from './views/programme/ProgrammeDetails.jsx';
import StagePlan from './views/plan/StagePlan.jsx';
import {ProjectDetails} from './views/ProjectDetails.jsx';
import {PortfolioReportRisk} from './views/portfolio/ReportRisk.jsx';
import Demo from './views/demo/Demo.jsx';

//import {EnableSAML2} from './views/admin/EnableSAML2.jsx';

function renderComponent(component,id) {
  if (document.getElementById(id)!==null) {
    ReactDOM.render(component,document.getElementById(id));
  }
}

renderComponent(<ProjectMenu {...window.APP_DATA}/>,'projectMenu');
renderComponent(<HighlightReport {...window.APP_DATA}/>,'highlight');
renderComponent(<Portfolio {...window.APP_DATA}/>,'index');
renderComponent(<Organization {...window.APP_DATA}/>,'organization');
renderComponent(<Risk {...window.APP_DATA}/>,'risk');
renderComponent(<Change {...window.APP_DATA}/>,'change');
renderComponent(<AccountCreated {...window.APP_DATA}/>,'accountCreated');
renderComponent(<TemplateOverview {...window.APP_DATA}/>,'templates');
renderComponent(<ReportContent {...window.APP_DATA}/>,'report');
renderComponent(<NewProject {...window.APP_DATA}/>,'newProject');
renderComponent(<NewProject {...window.APP_DATA}/>,'projectProperties');
renderComponent(<ProgrammeProperties {...window.APP_DATA}/>,'programmeProperties');
renderComponent(<NewExtremeProject {...window.APP_DATA}/>,'newExtremeProject');
renderComponent(<Search {...window.APP_DATA}/>,'search');
renderComponent(<ProjectDefinition {...window.APP_DATA}/>,'definition');
renderComponent(<ProjectProductDescription {...window.APP_DATA}/>,'quality');
renderComponent(<BusinessCase {...window.APP_DATA}/>,'businessCase');
renderComponent(<Plan {...window.APP_DATA}/>,'plan');
renderComponent(<RiskManagementApproach {...window.APP_DATA}/>,'riskApproach');
renderComponent(<ChangeControlApproach {...window.APP_DATA}/>,'changeApproach');
renderComponent(<CommunicationManagementApproach {...window.APP_DATA}/>,'communicationManagementApproach');
renderComponent(<ProjectSettings {...window.APP_DATA}/>,'projectSettings');
renderComponent(<Brief {...window.APP_DATA}/>,'brief');
renderComponent(<InitiationDocument {...window.APP_DATA}/>,'pid');
renderComponent(<Demo {...window.APP_DATA}/>,'demo');
renderComponent(<ProgrammeDetails {...window.APP_DATA}/>,'programme');
renderComponent(<StagePlan {...window.APP_DATA}/>,'stagePlanView');
renderComponent(<ProjectDetails {...window.APP_DATA}/>,'projectDetails');
renderComponent(<ProductProperties {...window.APP_DATA}/>,'productProperties');
renderComponent(<ReleaseProperties {...window.APP_DATA}/>,'releaseProperties');
renderComponent(<ProductDetails {...window.APP_DATA}/>,'product');
renderComponent(<PortfolioReportRisk {...window.APP_DATA}/>,'portfolioReportRisk');

//renderComponent(<EnableSAML2 {...window.APP_DATA}/>,'enableSAML2');



// WEBPACK FOOTER //
// ./client.js